export default __webpack_public_path__ + "static/media/12_USUN.7e056aed.png";